export default __webpack_public_path__ + "static/media/TTNormsPro-Medium.9fc3172e.woff2";